import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _UInt___init__impl__l7qpdl5ip6p2ldulrs as _UInt___init__impl__l7qpdl,
  UInt__toString_impl_dbgl212c25g5qzedjl1 as UInt__toString_impl_dbgl21,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _ULong___init__impl__c78o9k1vasxel72m2l4 as _ULong___init__impl__c78o9k,
  ULong__toString_impl_f9au7k36l427nkiqphd as ULong__toString_impl_f9au7k,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  _UByte___init__impl__g9hnc49zztd2brjj2m as _UByte___init__impl__g9hnc4,
  UByte__toString_impl_v72jg3k7aad61xjb4o as UByte__toString_impl_v72jg,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UShort___init__impl__jigrne1e3nphhrejdd8 as _UShort___init__impl__jigrne,
  UShort__toString_impl_edaoee2vx1is7vlchpz as UShort__toString_impl_edaoee,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ComposerClass;
function Composer() {
  if (ComposerClass === VOID) {
    class $ {
      constructor(writer) {
        this.writer_1 = writer;
        this.writingFirst_1 = true;
      }
      indent_cuntic_k$() {
        this.writingFirst_1 = true;
      }
      unIndent_45q4lx_k$() {
        return Unit_instance;
      }
      nextItem_40n9p2_k$() {
        this.writingFirst_1 = false;
      }
      nextItemIfNotFirst_9wb040_k$() {
        this.writingFirst_1 = false;
      }
      space_po67ue_k$() {
        return Unit_instance;
      }
      print_49c4ow_k$(v) {
        return this.writer_1.writeChar_9yrrvs_k$(v);
      }
      print_wtfns3_k$(v) {
        return this.writer_1.write_mozxwr_k$(v);
      }
      print_81xt5n_k$(v) {
        return this.writer_1.write_mozxwr_k$(v.toString());
      }
      print_3xddxz_k$(v) {
        return this.writer_1.write_mozxwr_k$(v.toString());
      }
      print_p65m4b_k$(v) {
        return this.writer_1.writeLong_vk8q1z_k$(fromInt(v));
      }
      print_l5t6fv_k$(v) {
        return this.writer_1.writeLong_vk8q1z_k$(fromInt(v));
      }
      print_ay1yo5_k$(v) {
        return this.writer_1.writeLong_vk8q1z_k$(fromInt(v));
      }
      print_u23kfb_k$(v) {
        return this.writer_1.writeLong_vk8q1z_k$(v);
      }
      print_u0bpvs_k$(v) {
        return this.writer_1.write_mozxwr_k$(v.toString());
      }
      printQuoted_gtxn2t_k$(value) {
        return this.writer_1.writeQuoted_k770v7_k$(value);
      }
    }
    initMetadataForClass($, 'Composer');
    ComposerClass = $;
  }
  return ComposerClass;
}
function Composer_0(sb, json) {
  return json.configuration_1.prettyPrint_1 ? new (ComposerWithPrettyPrint())(sb, json) : new (Composer())(sb);
}
var ComposerForUnsignedNumbersClass;
function ComposerForUnsignedNumbers() {
  if (ComposerForUnsignedNumbersClass === VOID) {
    class $ extends Composer() {
      constructor(writer, forceQuoting) {
        super(writer);
        this.forceQuoting_1 = forceQuoting;
      }
      print_ay1yo5_k$(v) {
        if (this.forceQuoting_1) {
          // Inline function 'kotlin.toUInt' call
          var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
          this.printQuoted_gtxn2t_k$(UInt__toString_impl_dbgl21(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUInt' call
          var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
          this.print_wtfns3_k$(UInt__toString_impl_dbgl21(tmp$ret$1));
        }
      }
      print_u23kfb_k$(v) {
        if (this.forceQuoting_1) {
          // Inline function 'kotlin.toULong' call
          var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
          this.printQuoted_gtxn2t_k$(ULong__toString_impl_f9au7k(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toULong' call
          var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
          this.print_wtfns3_k$(ULong__toString_impl_f9au7k(tmp$ret$1));
        }
      }
      print_p65m4b_k$(v) {
        if (this.forceQuoting_1) {
          // Inline function 'kotlin.toUByte' call
          var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
          this.printQuoted_gtxn2t_k$(UByte__toString_impl_v72jg(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUByte' call
          var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
          this.print_wtfns3_k$(UByte__toString_impl_v72jg(tmp$ret$1));
        }
      }
      print_l5t6fv_k$(v) {
        if (this.forceQuoting_1) {
          // Inline function 'kotlin.toUShort' call
          var tmp$ret$0 = _UShort___init__impl__jigrne(v);
          this.printQuoted_gtxn2t_k$(UShort__toString_impl_edaoee(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUShort' call
          var tmp$ret$1 = _UShort___init__impl__jigrne(v);
          this.print_wtfns3_k$(UShort__toString_impl_edaoee(tmp$ret$1));
        }
      }
    }
    initMetadataForClass($, 'ComposerForUnsignedNumbers');
    ComposerForUnsignedNumbersClass = $;
  }
  return ComposerForUnsignedNumbersClass;
}
var ComposerForUnquotedLiteralsClass;
function ComposerForUnquotedLiterals() {
  if (ComposerForUnquotedLiteralsClass === VOID) {
    class $ extends Composer() {
      constructor(writer, forceQuoting) {
        super(writer);
        this.forceQuoting_1 = forceQuoting;
      }
      printQuoted_gtxn2t_k$(value) {
        if (this.forceQuoting_1) {
          super.printQuoted_gtxn2t_k$(value);
        } else {
          super.print_wtfns3_k$(value);
        }
      }
    }
    initMetadataForClass($, 'ComposerForUnquotedLiterals');
    ComposerForUnquotedLiteralsClass = $;
  }
  return ComposerForUnquotedLiteralsClass;
}
var ComposerWithPrettyPrintClass;
function ComposerWithPrettyPrint() {
  if (ComposerWithPrettyPrintClass === VOID) {
    class $ extends Composer() {
      constructor(writer, json) {
        super(writer);
        this.json_1 = json;
        this.level_1 = 0;
      }
      indent_cuntic_k$() {
        this.writingFirst_1 = true;
        this.level_1 = this.level_1 + 1 | 0;
      }
      unIndent_45q4lx_k$() {
        this.level_1 = this.level_1 - 1 | 0;
      }
      nextItem_40n9p2_k$() {
        this.writingFirst_1 = false;
        this.print_wtfns3_k$('\n');
        // Inline function 'kotlin.repeat' call
        var times = this.level_1;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.print_wtfns3_k$(this.json_1.configuration_1.prettyPrintIndent_1);
          }
           while (inductionVariable < times);
      }
      nextItemIfNotFirst_9wb040_k$() {
        if (this.writingFirst_1)
          this.writingFirst_1 = false;
        else {
          this.nextItem_40n9p2_k$();
        }
      }
      space_po67ue_k$() {
        this.print_49c4ow_k$(_Char___init__impl__6a9atx(32));
      }
    }
    initMetadataForClass($, 'ComposerWithPrettyPrint');
    ComposerWithPrettyPrintClass = $;
  }
  return ComposerWithPrettyPrintClass;
}
//region block: exports
export {
  ComposerForUnquotedLiterals as ComposerForUnquotedLiterals3v0rwxdudtla9,
  ComposerForUnsignedNumbers as ComposerForUnsignedNumbers2h1dv6l9z3aef,
  Composer_0 as Composer1pt8hwk95abxi,
};
//endregion

//# sourceMappingURL=Composers.mjs.map
